import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios'
import VueAxios from 'vue-axios'
import App from './App.vue'
import router from './router'
import store from './store'

//地区选择器
import VDistpicker from 'v-distpicker'
Vue.component('v-distpicker', VDistpicker)

import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
  ak: 'zWaTCvbHPbbo6QgxTyYVIMGuoZrc7wXM'
})

//导入时间格式化插件
import moment from 'moment'
//定义全局的时间过滤器
Vue.filter('dateFilter', function(data, pattern = "YYYY-MM-DD HH:mm:ss") {
   return moment(data).format(pattern)
})

Vue.use(ElementUI);
Vue.use(VueAxios, axios)
// axios.defaults.baseURL = "http://192.168.3.50:9999"
axios.defaults.baseURL = "http://www.chinajzty.com/interface/"
Vue.prototype.$axios = axios
//添加请求拦截器
axios.interceptors.request.use((config) => {
  if (window.localStorage.getItem("userInfo")) {
    config.headers.Authorization = "Bearer " + JSON.parse(window.localStorage.getItem("userInfo")).token;
  }
  return config
}, err => {
  console.log(err)
})
//响应拦截器
axios.interceptors.response.use((res) => {
  if (res.data.code == 20008) {
      ElementUI.Message({
          message: '登录已过期，请重新登录！',
          type: 'success'
      });
      router.push({ path: "/login" })
  }
  return res
})
// import Swiper styles
import 'swiper/dist/css/swiper.css';
// Vue.use(Swiper)
console.log(Vue.config)
Vue.config.productionTip = false
// Vue.config.errorHandler = function (err, vm, info) {
//   console.error('error---', err)
//   console.info('vm---', vm)
//   console.info('info---', info)
// }

new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')
